import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchHubLatestPacks,
  fetchAllLatestBundlePacks,
  fetchPacksNoPaginated,
  fetchPacksSummary,
  latestEnablePacks,
  latestDisablePacks
} from "illuminate/hooks/api/packs";
export const packEntitiesKeyFn = (searchParams) => ["content-hub", "packs", searchParams];
export function useFetchLatestPacks() {
  return { packEntitiesKeyFn, fetchHubLatestPacks };
}
export function useFetchAllLatestBundlePacks() {
  const { isLoading, data } = useQuery({
    queryKey: ["illuminate-hub-all-latest-bundle-packs"],
    queryFn: fetchAllLatestBundlePacks
  });
  return {
    fetchingAllPacks: isLoading,
    allPacks: data != null ? data : []
  };
}
export function useGetFilteredPacks(filters) {
  const { data, isLoading } = useQuery({
    queryKey: ["latest-packs-no-paginated", filters],
    queryFn: () => fetchPacksNoPaginated(filters)
  });
  return {
    filteredPacks: data || [],
    loadingFilteredPacks: isLoading
  };
}
export const ILLUMINATE_STORE_VERSION_KEY = "illuminate_skipped_bundle_version";
export function useGetPacksSummary() {
  const { data, isLoading } = useQuery({
    queryKey: ["latest-packs-summary"],
    queryFn: fetchPacksSummary,
    refetchInterval: 60 * 60 * 1e3
  });
  return {
    packsSummary: data != null ? data : {
      new_packs_available: false,
      updated_packs_available: false,
      cached_version: null,
      current_version: "0.0.1"
    },
    loadingPacksSummary: isLoading
  };
}
export function useEnableLatestPacks() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: latestEnablePacks,
    onSuccess: () => {
      const fetchPacksKey = packEntitiesKeyFn();
      queryClient.invalidateQueries({ queryKey: fetchPacksKey });
    }
  });
  return { enablePacks: mutateAsync, enablingPacks: isLoading };
}
export function useDisableLatestPacks() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: latestDisablePacks,
    onSuccess: () => {
      const fetchPacksKey = packEntitiesKeyFn();
      queryClient.invalidateQueries({ queryKey: fetchPacksKey });
    }
  });
  return { disablePacks: mutateAsync, disablingPacks: isLoading };
}
